import { HTTP_INTERCEPTORS } from '@angular/common/http';
import type { Provider } from '@angular/core';
import { IdentityInterceptor } from '@app/interceptor/identity/identity.interceptor';
import { HttpTimeoutInterceptor } from '@app/interceptor/http/timeout/http-timeout.interceptor';
import { UserProfileInterceptor } from '@app/interceptor/user/profile/user-profile.interceptor';
import { SessionTimeoutInterceptor } from '@app/interceptor/session/timeout/session-timeout.interceptor';
import { HttpErrorInterceptor } from '@app/interceptor/http/error/http-error.interceptor';

export * from './interceptor-logic';

export const HTTP_INTERCEPTOR_PROVIDERS: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: IdentityInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpTimeoutInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UserProfileInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SessionTimeoutInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
];
